export class OfflineNotEnabledError extends Error {
  constructor() {
    super("Offline mode is disabled.");
    this.name = "OfflineNotEnabledError";
  }
}

export class OfflineCacheMissError extends Error {
  constructor(message = "No cached data available for offline request.") {
    super(message);
    this.name = "OfflineCacheMissError";
  }
}

export class OfflineQueueError extends Error {
  constructor(message = "Failed to enqueue offline submission.") {
    super(message);
    this.name = "OfflineQueueError";
  }
}

export class OfflineRequestQueuedError<T = unknown> extends Error {
  readonly queueEntry: T;
  constructor(entry: T, message = "Request enqueued for offline processing.") {
    super(message);
    this.name = "OfflineRequestQueuedError";
    this.queueEntry = entry;
  }
}
